import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { InputEl } from "common/components/input";
import { SvgIconEl } from "common/components/svg-icon";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { SpinnerEl } from "common/components/spinner";
import { RadioButtonEl } from "common/components/radio-button";
import { DateRangePickerEl } from "common/widgets/date-range-picker";
import { ButtonBarEl } from "common/components/button-bar";
export function template() {
  const { editingPropertyType, propertyFilter, searchFilter } = this.state;
  const FilterOperatorDropdown = () => /* @__PURE__ */ jsx(SelectEl, {
    sel: ".pvs-filter-operator-dropdown",
    attrs: {
      options: this.helpers.getFilterOperators(),
      "selected-option": propertyFilter.filterOperator
    },
    on: {
      change: (ev) => this.helpers.changeFilterOperator(ev.detail.value)
    }
  });
  const FilterNumberInput = ({
    value = ``,
    onInput = null,
    autofocus = false,
    key = null
  }) => /* @__PURE__ */ jsx(InputEl, {
    sel: ".pvs-filter-numdate-input",
    attrs: {
      type: `number`
    },
    props: {
      value: value == null ? void 0 : value.toString()
    },
    on: {
      input: onInput
    },
    hook: {
      insert: autofocus ? this.helpers.focusInput : null
    },
    key
  });
  const FilterStringInput = () => {
    var _a;
    return /* @__PURE__ */ jsx(InputEl, {
      sel: ".pvs-filter-string-input",
      attrs: {
        elref: `filterValueInput`,
        "select-on-focus": true,
        type: `text`,
        icon: `search`,
        placeholder: `Search`
      },
      props: {
        value: (_a = propertyFilter.filterValue) == null ? void 0 : _a.toString()
      },
      on: {
        input: (ev) => this.helpers.changeFilterValue(ev.target.value)
      },
      key: `string-${propertyFilter.filterOperator}`,
      hook: {
        insert: this.helpers.focusInput
      }
    });
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".pvs-container",
    class: {
      "pvs-display-context-custom-event": this.helpers.getDisplayContext() === this.helpers.PropertyFilterDisplayContext.CustomEvent
    },
    hook: { postpatch: this.helpers.dispatchDraw }
  }, !this.attr(`display-value-only`) ? /* @__PURE__ */ jsx("div", {
    sel: ".pvs-title-section"
  }, this.helpers.hasBackButton() ? /* @__PURE__ */ jsx("div", {
    sel: ".pvs-back-button",
    on: {
      click: this.helpers.clickBackButton
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `caret-left` }
  })) : null, /* @__PURE__ */ jsx("div", {
    sel: ".pvs-property-type-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".pvs-property-type-button",
    class: { "pvs-property-type-button-enabled": this.helpers.canTypeCast() },
    on: {
      click: this.helpers.clickPropertyTypeButton
    }
  }, (() => {
    const propertyLabel = this.helpers.getPropertyLabel();
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: this.helpers.getPropertyTypeIcon() }
    }), /* @__PURE__ */ jsx("span", {
      sel: ".pvs-property-type-label",
      attrs: {
        title: propertyLabel
      }
    }, this.helpers.truncateMiddle(propertyLabel, 30)), this.helpers.canTypeCast() ? /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `caret-down` }
    }) : null);
  })()), this.helpers.canTypeCast() ? /* @__PURE__ */ jsx("div", {
    sel: ".pvs-property-types-menu"
  }, /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: { open: editingPropertyType },
    on: {
      change: this.helpers.changePropertyTypesMenu
    }
  }, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      sections: this.helpers.getPropertyTypeMenuSections()
    },
    on: {
      clickItem: this.helpers.clickPropertyTypesMenuItem
    }
  }))) : null)) : null, /* @__PURE__ */ jsx("div", {
    sel: ".pvs-filter-section"
  }, (() => {
    const { propertyType, propertyObjectKey } = propertyFilter;
    return /* @__PURE__ */ jsx(null, null, this.helpers.enhancedListFilterEnabled() ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-list-options"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-option-label"
    }, "Match"), /* @__PURE__ */ jsx(SelectEl, {
      sel: ".pvs-filter-list-quantifier",
      attrs: {
        sections: this.helpers.getListQuantifierSections()
      },
      on: {
        change: this.helpers.handleListQuantifierSelect
      }
    })) : null, propertyType === this.helpers.PropertyType.Object ? this.helpers.isLoadingPropertyValues() ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-property-values-loading"
    }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection.pvs-filter-for-object.pvs-first-subsection"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-label"
    }, "Where"), /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        "selected-option": propertyObjectKey === null ? `Choose a key` : ``,
        sections: this.helpers.getPropertyValueSections(),
        tabindex: 0
      },
      on: { change: this.helpers.selectObjectPropertyKey }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection.pvs-filter-for-object"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-label"
    }, "Equals"), /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        disabled: propertyObjectKey === null,
        "selected-option": propertyObjectKey === null ? `Select a key first` : ``,
        sections: this.helpers.getObjectPropertyValueSections(),
        tabindex: 0
      },
      on: { change: this.helpers.selectObjectPropertyValue },
      props: { sectionsFromInputFn: this.helpers.sectionsFromInputFn }
    }))) : propertyType === this.helpers.PropertyType.Number ? /* @__PURE__ */ jsx(null, null, !this.attr(`display-value-only`) ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection.pvs-first-subsection"
    }, /* @__PURE__ */ jsx(FilterOperatorDropdown, null)) : null, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection",
      class: {
        "pvs-filter-numdate-between": propertyFilter.filterOperator === this.helpers.NumberOperator.Between
      }
    }, propertyFilter.filterOperator === this.helpers.NumberOperator.Between || propertyFilter.filterOperator === this.helpers.NumberOperator.NotBetween ? (() => {
      const [minNum, maxNum] = propertyFilter.filterValue;
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(FilterNumberInput, {
        value: minNum,
        onInput: (ev) => this.helpers.changeFilterValue([this.helpers.parseNumber(ev.target.value), maxNum]),
        autofocus: true,
        key: "num-min"
      }), /* @__PURE__ */ jsx("div", {
        sel: ".pvs-filter-conjunction"
      }, "and"), /* @__PURE__ */ jsx(FilterNumberInput, {
        value: maxNum,
        onInput: (ev) => this.helpers.changeFilterValue([minNum, this.helpers.parseNumber(ev.target.value)]),
        autofocus: false,
        key: "num-max"
      }));
    })() : /* @__PURE__ */ jsx(FilterNumberInput, {
      value: propertyFilter.filterValue,
      onInput: (ev) => this.helpers.changeFilterValue(this.helpers.parseNumber(ev.target.value)),
      autofocus: true,
      key: `num-val-${propertyFilter.filterOperator}`
    }))) : propertyType === this.helpers.PropertyType.Boolean || propertyType === this.helpers.PropertyType.List ? /* @__PURE__ */ jsx(null, null, !this.attr(`display-value-only`) ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection.pvs-filter-radio-list.pvs-first-subsection"
    }, this.helpers.getFilterOperators().map((filterOperator) => /* @__PURE__ */ jsx("div", {
      sel: ".pvs-radio-button-container"
    }, /* @__PURE__ */ jsx(RadioButtonEl, {
      className: "pvs-radio-button",
      selected: filterOperator === propertyFilter.filterOperator,
      onClick: () => this.helpers.changeFilterOperator(filterOperator),
      children: filterOperator
    })))) : null, propertyType === this.helpers.PropertyType.List ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection"
    }, /* @__PURE__ */ jsx(FilterStringInput, null)) : null) : propertyType === this.helpers.PropertyType.String ? /* @__PURE__ */ jsx(null, null, !this.attr(`display-value-only`) ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection.pvs-first-subsection"
    }, /* @__PURE__ */ jsx(FilterOperatorDropdown, null)) : null, propertyFilter.filterOperator === this.helpers.StringOperator.Contains || propertyFilter.filterOperator === this.helpers.StringOperator.DoesNotContain ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection"
    }, /* @__PURE__ */ jsx(FilterStringInput, null)), this.helpers.isLoadingPropertyValues() ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-property-values-loading"
    }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-property-values"
    }, /* @__PURE__ */ jsx(ItemsMenuEl, {
      sel: ".pvs-property-value-list",
      attrs: this.helpers.filterAttributes({
        "search-exact": true,
        "search-filter": propertyFilter.filterValue ? this.helpers.renamePropertyValue(propertyFilter.filterValue) : null
      }),
      on: {
        clickItem: (ev) => this.helpers.selectContainsPropertyValue(ev.detail.item.propertyValue),
        draw: this.helpers.propagateEvent
      },
      props: {
        sections: this.helpers.getPropertyValueSections(),
        keydownProxyEl: this.helpers.getKeydownProxyEl()
      }
    }))) : propertyFilter.filterOperator === this.helpers.StringOperator.Equals || propertyFilter.filterOperator === this.helpers.StringOperator.DoesNotEqual ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-fixed-subsection"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        elref: `filterValueInput`,
        icon: `search`,
        placeholder: `Search`
      },
      props: { value: searchFilter },
      key: `string-${propertyFilter.filterOperator}`,
      hook: { insert: this.helpers.insertedIconInput },
      on: { input: (ev) => this.helpers.changeSearchFilter(ev.target.value) }
    })), this.helpers.isLoadingPropertyValues() && !searchFilter ? /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-property-values-loading"
    }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx("div", {
      sel: ".pvs-filter-property-values"
    }, /* @__PURE__ */ jsx(ItemsMenuEl, {
      attrs: this.helpers.filterAttributes({
        "search-filter": searchFilter,
        "show-csv-matches": true,
        "show-select-all": !this.attr(`disable-multi-select`),
        "show-select-all-matching": !this.attr(`disable-multi-select`),
        multiple: !this.attr(`disable-multi-select`),
        elref: `string-property-select-menu`
      }),
      on: {
        selectAllMatching: this.helpers.selectAllMatching,
        selectAll: this.helpers.selectAllPropertyValues,
        clickItem: (ev) => this.helpers.toggleFilterItem(ev.detail.item),
        draw: this.helpers.propagateEvent
      },
      props: {
        sectionsFromInputFn: this.helpers.sectionsFromInputFn,
        sections: this.helpers.getPropertyValueSections(),
        keydownProxyEl: this.helpers.getKeydownProxyEl()
      }
    }))) : null) : propertyType === this.helpers.PropertyType.Datetime ? /* @__PURE__ */ jsx(DateRangePickerEl, {
      attrs: this.helpers.filterAttributes({
        "display-context": this.helpers.getDateRangePickerDisplayContext(),
        "date-range": propertyFilter.filterValue.getAttributes()
      }),
      on: {
        changeDateRange: this.helpers.changeDateRange,
        draw: this.helpers.propagateEvent
      }
    }) : null);
  })()), /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: ".mp-button-bar-primary",
    attrs: {
      disabled: !propertyFilter.isValid(),
      tabindex: 0
    },
    on: {
      click: this.helpers.clickAddFilter
    }
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `apply` }
  }, "Add")));
}
